<template>
  <v-data-table
    :headers="getMainTableHeaders"
    :items="getVouchersList"
    :total-items="totalItems"
    :loading="loading"
    :pagination="paginationData"
    :rows-per-page-items="[5, 10, 25, 50, 100]"
    @update:pagination="onPaginationUpdate"
    sort-icon="fa-arrow-down" class="elevation-1 main-table"
  >
    <template slot="items" slot-scope="props">
      <td>#{{ props.item.voucher_number }}</td>
      <td>{{ props.item.invoice_number }}</td>
      <td>
        <router-link
          v-if="props.item.debit_notes && props.item.debit_notes.length"
          :to="{name: 'DebitNoteDetails', params: {noteId: props.item.debit_notes[0].id}}"
          class="debit-note-link"
        >
          {{ props.item.debit_notes[0].number }}
        </router-link>
        <span v-else>—</span>
      </td>
      <td>{{ props.item.name }}</td>
      <td>{{ props.item.type ? props.item.type.name : 'Brak'}}</td>
      <td>{{ props.item.status | convertStatusToName }}</td>
      <td>{{ moment(props.item.expired_at).format('DD-MM-YYYY')}}</td>
      <td>PLN {{ props.item.price }}</td>
      <td>PLN {{ props.item.realized_value }}</td>
      <td class="text-xs-center">
        <div>
          <v-btn small color="#555474"
                 @click="$router.push({name:'VoucherDetails', params: {voucherId: props.item.id}})" dark>Zobacz
          </v-btn>
          <v-menu bottom offset-y>
            <v-btn small slot="activator">Więcej
              <v-icon size="15px" class="ml-2 mr-0">fas fa-caret-down</v-icon>
            </v-btn>
            <v-list class="v-list--button-list">
              <v-list-tile v-permissions
                           v-if="props.item.status !== 'F'"
                           @click="$router.push({name: 'EditExpiredAt', params: {voucherId: props.item.id}})">
                <v-list-tile-title>Edytuj datę</v-list-tile-title>
              </v-list-tile>
              <v-list-tile v-permissions
                           v-if="props.item.status === 'N'"
                           @click="$router.push({name: 'EditPrice', params: {voucherId: props.item.id}})">
                <v-list-tile-title>Edytuj wartość</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="$emit('printPDF',props.item.id)">
                <v-list-tile-title>Drukuj</v-list-tile-title>
              </v-list-tile>
              <v-list-tile v-if="!props.item.debit_notes || !props.item.debit_notes.length"
                           @click="$router.push({name: 'CreateDebitNote', query: {voucher_id: props.item.id}})">
                <v-list-tile-title>Wystaw notę</v-list-tile-title>
              </v-list-tile>
              <v-list-tile v-if="!props.item.debit_notes || !props.item.debit_notes.length"
                           @click="$emit('addToNote', props.item.id, props.item.voucher_number)">
                <v-list-tile-title>Dodaj do noty</v-list-tile-title>
              </v-list-tile>
              <v-list-tile v-if="props.item.debit_notes && props.item.debit_notes.length"
                           @click="$router.push({name: 'DebitNoteDetails', params: {noteId: props.item.debit_notes[0].id}})">
                <v-list-tile-title>Zobacz notę ({{ props.item.debit_notes[0].number }})</v-list-tile-title>
              </v-list-tile>
              <v-list-tile v-if="props.item.status !== 'F'"
                           @click="$router.push({name: 'AddRealization', params: {voucherId: props.item.id}})">
                <v-list-tile-title>Dodaj realizację</v-list-tile-title>
              </v-list-tile>
              <v-list-tile v-if="props.item.status === 'N'"
                           v-permissions
                           @click="$emit('deleteVoucher',props.item.id, 'deleteVoucher', false)"
                           class="v-menu--v-list-title-delete">
                <v-list-tile-title>Usuń</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="$router.push({name: 'EditVoucher', params: {voucherId: props.item.id}})">
                <v-list-tile-title>Edytuj</v-list-tile-title>
              </v-list-tile>
              <v-list-tile
                @click="$emit('exportPDF', props.item.id, `${props.item.id}_${moment(props.item.created_at).format('YYYY')}`, props.item.type ? props.item.type.name : 'Brak')">
                <v-list-tile-title>Eksportuj PDF</v-list-tile-title>
              </v-list-tile>
              <v-list-tile v-if="props.item.status === 'I'"
                           @click="$emit('finishVoucher',props.item.id, 'deactivateVoucher', true)"
                           class="v-menu--v-list-title-delete">
                <v-list-tile-title>Zakończ</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>
      </td>
    </template>
    <template slot="footer">
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td>
        <strong>Suma</strong>
      </td>
      <td>
        <strong>PLN {{calculateAllValues('price')}}</strong>
      </td>
      <td>
        <strong>PLN {{calculateAllValues('realized_value')}}</strong>
      </td>
      <td></td>
    </template>
  </v-data-table>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'VoucherTable',
    props: {
      loading: Boolean,
      totalItems: { type: Number, default: 0 },
      currentPage: { type: Number, default: 1 },
    },
    data() {
      return {
        initialized: false,
        paginationData: {
          descending: false,
          page: 1,
          rowsPerPage: 10,
        },
      };
    },
    mounted() {
      this.$nextTick(() => { this.initialized = true; });
    },
    watch: {
      currentPage(val) {
        this.paginationData = Object.assign({}, this.paginationData, { page: val });
      },
    },
    computed: {
      ...mapGetters('AuthStore', ['getUserRole']),
      ...mapGetters('VoucherStore', ['getMainTableHeaders', 'getRealizationsHeaders', 'getVouchersList']),
    },
    methods: {
      onPaginationUpdate(pagination) {
        this.paginationData = pagination;
        if (this.initialized) {
          this.$emit('paginationChange', pagination);
        }
      },
      calculateAllValues(key) {
        if (this.getVouchersList.length > 0) {
          const result = this.getVouchersList
            .map(item => Number(item[key]) || 0)
            .reduce((a, b) => a + b);
          return result || 0;
        }
        return 0;
      },
    },
    filters: {
      convertStatusToName(status) {
        switch (status) {
          case 'F':
            return 'Zakończone';
          case 'N':
            return 'Nowe';
          case 'I':
            return 'W realizacji';
          default:
            return 'Nieznany status';
        }
      },
    },
  };
</script>

<style scoped>
  .debit-note-link {
    color: #555474;
    font-weight: 600;
    text-decoration: none;
  }

  .debit-note-link:hover {
    text-decoration: underline;
  }
</style>
